/**
 * Created by piotr.pozniak@thebeaverhead.com on 17/08/2022
 *
 * @param {object} integration
 * @param {string=""} wrapperClassName
 */
import React from "react";
import { ucFirst } from "../../../../helpers/string";
import { Link } from "react-router-dom";
import ExpandableAlert from "../ExpandableAlert";

const PermissionsAlert = ({ integration, wrapperClassName = "" }) => {
  const scopesWithIssue = integration.integration_scopes.filter(
    (i) => i.available && !i.has_permissions
  );

  const scopesList = scopesWithIssue.map((i) => (
    <strong
      key={`${integration.uuid}-se-${i.name}`}
      className={"alert-permission-scope"}
    >
      {ucFirst(i.name)}
    </strong>
  ));

  return (
    <ExpandableAlert
      errorLevel={"warning"}
      wrapperClassName={wrapperClassName}
      header={
        <span>
          Your {integration.name} sync is paused due to permissions issue
          in scope
          {scopesList.length > 1 ? "s" : ""} {scopesList}.
        </span>
      }
      body={
        <React.Fragment>
          <span>{integration.last_error_message}</span>
          <br />
          <span>
            Ensure you have granted all necessary permissions or{" "}
            <Link
              to={`/integrations?settings=${integration.uuid}&reason=permissions`}
              className={"alert-link"}
            >
              update integration scopes
            </Link>
            .
          </span>
        </React.Fragment>
      }
      icon={"error"}
    />
  );
};

export default PermissionsAlert;
